import React from 'react';

// Render a boolean icon: check for true, xmark for false, empty circle for null/undefined
const BooleanIcon = ({ value, muted = false }) => {
  if (value === null || value === undefined) {
    return (
      <i
        className={`fa-regular fa-circle text-lg ${muted ? 'text-gray-300' : 'text-green-600'} inline`}
      />
    );
  }
  if (value === true) {
    return (
      <i
        className={`fa-regular fa-circle-check text-lg ${muted ? 'text-gray-400' : 'text-green-600'} inline`}
      />
    );
  }
  // false
  return (
    <i
      className={`fa-regular fa-circle-xmark text-lg ${muted ? 'text-gray-400' : 'text-red-500'} inline`}
    />
  );
};

export default function BooleanDiff({ beforeValue, afterValue }) {
  const changed = beforeValue !== afterValue;

  if (!changed) {
    return (
      <span className="text-gray-500">
        <BooleanIcon value={afterValue} />
      </span>
    );
  }

  return (
    <div className="flex items-center space-x-2">
      <span className="flex items-center">
        <BooleanIcon value={beforeValue} muted />
      </span>
      <span className="text-gray-400">
        <i className="fa fa-arrow-right" />
      </span>
      <span className="flex items-center">
        <BooleanIcon value={afterValue} />
      </span>
    </div>
  );
}
